import { SorterRule } from 'src/components/sorter-rule';

export default SorterRule;
